import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, CheckCircleIcon } from 'lucide-react';
const buyers = [{
  name: 'Valentina R.',
  city: 'Córdoba',
  gender: 'female',
  minutes: 3
}, {
  name: 'Diego M.',
  city: 'Rosario',
  gender: 'male',
  minutes: 7
}, {
  name: 'Marcos D.',
  city: 'Buenos Aires',
  gender: 'male',
  minutes: 12
}, {
  name: 'Luciana F.',
  city: 'Mendoza',
  gender: 'female',
  minutes: 2
}, {
  name: 'Sebastián G.',
  city: 'CABA',
  gender: 'male',
  minutes: 5
}, {
  name: 'Carolina P.',
  city: 'Rosario',
  gender: 'female',
  minutes: 9
}, {
  name: 'Facundo L.',
  city: 'Tucumán',
  gender: 'male',
  minutes: 4
}, {
  name: 'Camila S.',
  city: 'La Plata',
  gender: 'female',
  minutes: 6
}];
const maleAvatars = ['https://randomuser.me/api/portraits/men/32.jpg', 'https://randomuser.me/api/portraits/men/45.jpg', 'https://randomuser.me/api/portraits/men/22.jpg', 'https://randomuser.me/api/portraits/men/67.jpg'];
const femaleAvatars = ['https://randomuser.me/api/portraits/women/44.jpg', 'https://randomuser.me/api/portraits/women/68.jpg', 'https://randomuser.me/api/portraits/women/33.jpg', 'https://randomuser.me/api/portraits/women/55.jpg'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 5000);
    }, 5000);
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % buyers.length);
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 5000);
    }, 20000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  const buyer = buyers[currentIndex];
  const avatarList = buyer.gender === 'male' ? maleAvatars : femaleAvatars;
  const avatar = avatarList[currentIndex % avatarList.length];
  return <AnimatePresence data-id="element-225">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 max-w-xs bg-[#111] border border-gold/40 rounded-xl p-4 shadow-glow-gold/20 flex items-center gap-3" data-id="element-226">
          <img src={avatar} alt={buyer.name} className="w-11 h-11 rounded-full object-cover border-2 border-gold/40 shrink-0" data-id="element-227" />
          <div className="flex-1 min-w-0" data-id="element-228">
            <div className="flex items-center gap-2 mb-0.5" data-id="element-229">
              <span className="text-sm font-bold text-white truncate" data-id="element-230">
                {buyer.name}
              </span>
              <span className="text-[10px] text-smoke/50" data-id="element-231">{buyer.city}</span>
            </div>
            <div className="flex items-center gap-1.5 mb-0.5" data-id="element-232">
              <CheckCircleIcon className="w-3.5 h-3.5 text-green-400 shrink-0" data-id="element-233" />
              <span className="text-xs font-bold text-green-400 uppercase tracking-wide" data-id="element-234">
                Compra verificada
              </span>
            </div>
            <p className="text-xs text-smoke/70" data-id="element-235">
              Compró el{' '}
              <span className="text-gold font-medium" data-id="element-236">Combo Completo</span> hace{' '}
              {buyer.minutes} min
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-smoke/50 hover:text-white transition-colors shrink-0 self-start" data-id="element-237">
            <XIcon className="w-4 h-4" data-id="element-238" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}